import axios, { AxiosResponse } from 'axios';
import {AllMessageEventsByDateParams} from "/site/parts/calendar/calendar.types";

/**
 * Получение списка сообщений/событий по дате
 */
export const getAllMessageEventsByDate = (params: AllMessageEventsByDateParams): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/get-all-message-events-by-date', { params });
};


/**
 * Получение дат, которые имеют сообщения/события за месяц
 */
export const getMessageEventsInfoForPeriod = (currentMonth: string): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/get-message-events-info-for-period?yearMonth=${currentMonth}`);
};
